import type { CreatePortPdaColumnDto, PortPdaColumnDto, UpdatePortPdaColumnDto } from './models';
import { RestService, Rest } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';
import type { DataRequestDto, EntitySchemaDto, IdNameDto, PageRequestDto } from '../models';

@Injectable({
  providedIn: 'root',
})
export class PortPdaColumnService {
  private restService = inject(RestService);
  apiName = 'Default';
  

  create = (input: CreatePortPdaColumnDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PortPdaColumnDto>({
      method: 'POST',
      headers: { Accept: 'application/json' },
      url: '/api/app/port-pda-column',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  delete = (id: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/app/port-pda-column/${id}`,
    },
    { apiName: this.apiName,...config });
  

  get = (id: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PortPdaColumnDto>({
      method: 'GET',
      headers: { Accept: 'application/json' },
      url: `/api/app/port-pda-column/${id}`,
    },
    { apiName: this.apiName,...config });
  

  getCount = (input: PageRequestDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, number>({
      method: 'GET',
      headers: { Accept: 'application/json' },
      url: '/api/app/port-pda-column/count',
      params: { filter: input.filter, onlyActive: input.onlyActive, additionalData: input.additionalData, ignoreMaxResultCount: input.ignoreMaxResultCount, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getDropDownOptions = (input: DataRequestDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<IdNameDto>>({
      method: 'GET',
      headers: { Accept: 'application/json' },
      url: '/api/app/port-pda-column/drop-down-options',
      params: { select: input.select, filter: input.filter, onlyActive: input.onlyActive, additionalData: input.additionalData, ignoreMaxResultCount: input.ignoreMaxResultCount, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getExpandById = (id: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PortPdaColumnDto[]>({
      method: 'GET',
      headers: { Accept: 'application/json' },
      url: `/api/app/port-pda-column/${id}/expand`,
    },
    { apiName: this.apiName,...config });
  

  getExtraPropertiesById = (id: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, Record<string, object>>({
      method: 'GET',
      headers: { Accept: 'application/json' },
      url: `/api/app/port-pda-column/${id}/extra-properties`,
    },
    { apiName: this.apiName,...config });
  

  getIds = (input: DataRequestDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, string[]>({
      method: 'GET',
      headers: { Accept: 'application/json' },
      url: '/api/app/port-pda-column/ids',
      params: { select: input.select, filter: input.filter, onlyActive: input.onlyActive, additionalData: input.additionalData, ignoreMaxResultCount: input.ignoreMaxResultCount, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getList = (input: PageRequestDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<PortPdaColumnDto>>({
      method: 'GET',
      headers: { Accept: 'application/json' },
      url: '/api/app/port-pda-column',
      params: { filter: input.filter, onlyActive: input.onlyActive, additionalData: input.additionalData, ignoreMaxResultCount: input.ignoreMaxResultCount, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getOneExtraPropertiesByIdAndKey = (id: string, key: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, object>({
      method: 'GET',
      url: `/api/app/port-pda-column/${id}/one-extra-properties`,
      params: { key },
    },
    { apiName: this.apiName,...config });
  

  getSchema = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, EntitySchemaDto>({
      method: 'GET',
      headers: { Accept: 'application/json' },
      url: '/api/app/port-pda-column/schema',
    },
    { apiName: this.apiName,...config });
  

  getWithDetails = (id: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PortPdaColumnDto>({
      method: 'GET',
      headers: { Accept: 'application/json' },
      url: `/api/app/port-pda-column/${id}/with-details`,
    },
    { apiName: this.apiName,...config });
  

  setExtraPropertiesByIdAndKeyAndValue = (id: string, key: string, value: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'POST',
      url: `/api/app/port-pda-column/${id}/set-extra-properties`,
      params: { key, value },
    },
    { apiName: this.apiName,...config });
  

  update = (id: string, input: UpdatePortPdaColumnDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PortPdaColumnDto>({
      method: 'PUT',
      headers: { Accept: 'application/json' },
      url: `/api/app/port-pda-column/${id}`,
      body: input,
    },
    { apiName: this.apiName,...config });
}